<template>
    <el-dialog title="添加考核项" v-model="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :label-position="labelPosition"  ref="form" :model="Dform" :rules="rules">
            <el-form-item prop="name" label="任务名称" label-width="100px">
                <el-input v-model="Dform.name"></el-input>
            </el-form-item>

            <el-form-item prop="radio" label="分值录入方式" label-width="100px">
                <!-- <el-input  v-model="Dform.name"  ></el-input> -->
                <el-radio v-model="Dform.radio" label="1">固定选项</el-radio>
                <el-radio v-model="Dform.radio" label="0">手动输入</el-radio>
            </el-form-item>

            <el-form-item prop="name" label="打分标准" v-if="Dform.radio == '0'" label-width="100px">
                <el-input v-model="inputList2[0].scoreStandard" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
            </el-form-item>

            <el-row v-if="Dform.radio == '0'" >
                <div class="dafen_box" >
                        <el-form-item label="单次打分范围" label-width="100px" >
                            <el-input v-model="inputList2[0].lowestScore" placeholder="请输入最低分" @input="handleInput($event,item,3)" ></el-input>

                        </el-form-item>
                        <el-form-item label="" class="inp_hou">
                            <el-input v-model="inputList2[0].highestScore" placeholder="请输入最高分" @input="handleInput($event,item,4)"></el-input>
                        </el-form-item>
                   </div>
            </el-row>

            <el-row  v-if="Dform.radio == '1'">
                   <div class="dafen_box" v-for="(item,index) in inputList" :key="index">
                        <el-form-item :label="index == 0?'打分标准':'' " label-width="100px" >
                            <el-input v-model="item.scoreStandard" placeholder="请输入考核内容，如：迟到、早退等" @input="handleInput($event,item,1)"></el-input>
                        </el-form-item>
                        <el-form-item label="" class="inp_hou">
                            <el-input v-model="item.score" placeholder="输入得分，如：-1" ></el-input>
                        </el-form-item>
                        <CirclePlus class="jiahao_img" @click="gradeAdd()" v-if="index == 0"></CirclePlus>
                        <RemoveFilled  class="jiahao_img" @click="gradeDelete(item,index)" v-else></RemoveFilled >
                   </div>
            </el-row>
            <div class="buttom-box">
                <el-button type="primary" @click="AddClick()" :loading="loading">提交</el-button>
                <el-button @click="handleClose">返回</el-button>
            </div>
        </el-form>

    </el-dialog>
</template>
<script>
// import { addOrUpdate } from '@/assets/api/api'
import { addOrUpdate, } from '@/assets/api/deyu.js'
// import { CirclePlus  } from 'element-plus'
import { CirclePlus,RemoveFilled  } from "@element-plus/icons-vue"; // 图标


export default {
    components: {
        CirclePlus,
        RemoveFilled 
    },
    props: ['ItemInfoobj','addItem','addtilie'],
    data() {

        return {
            value:'',
            labelPosition: 'left',
            dialogVisible: true,
            loading: false,
            title: '',
            Dform: {
                name: '',
                radio: '1',
            },
            cardid: "",
            schoolList: [],
            inputList: [
                {
                    score: '',
                    scoreStandard: '',
                    highestScore: '',
                    lowestScore: '',
                    standardId: ''
                }
            ],
            inputListDuibi: [],
            inputList2: [
                {
                    score: '',
                    scoreStandard: '',
                    highestScore: '',
                    lowestScore: '',
                    standardId: ''
                }
            ],
            deleteStandardIdsList:[]
        }

    },
    created() {

    },
    mounted() {
        if ( this.addtilie == '编辑' ) {
            let addItemData = JSON.parse(this.addItem) 
            console.log(addItemData,'编辑',JSON.parse(this.addItem).id );
            this.Dform.name = addItemData.name
            this.Dform.radio = addItemData.addScoreType +''
            // if ( addItemData.addScoreType == 1 ) {
                this.inputList = addItemData.checkScoreStandards
                this.inputListDuibi = JSON.stringify(addItemData.checkScoreStandards)
            // } else if ( addItemData.addScoreType == 0 ) {
                this.inputList2 = addItemData.checkScoreStandards
                // this.inputListDuibi = JSON.stringify(addItemData.checkScoreStandards)
            // }
            
        }
        console.log(this.ItemInfoobj, 1111);
    },
    methods: {
        handleInput(value,item,str) {
            // 只允许数字
            console.log(value,item,str);
            if ( str == 1 ) {
                // item.scoreStandard = value.replace(/[^\d]/g, '');
                if ( item.id && item.id != '') {
                    // for (let value of this.deleteStandardIdsList) {
                    //     if ( item.id  )
                    // }
                    let str = this.deleteStandardIdsList.filter((value) => value.id == item.id)
                    if ( !str.length ) {
                        this.deleteStandardIdsList.push(item.id)
                    }
                    console.log(str,'99999999999');
                }
            } else if (str == 2) {
                item.score = value.replace(/[^\d]/g, '');
            } else if ( str == 3 ) {
                item.highestScore = value.replace(/[^\d]/g, '');
            } else if ( str == 4 ) {
                item.lowestScore = value.replace(/[^\d]/g, '');
            }
        },
        gradeAdd () {
            this.inputList.push({
                score: '',
                scoreStandard: '',
            })
        },
        gradeDelete (item,index) {
            if ( this.addtilie == '编辑' ) {
                if( item.id && item.id != '' ) {
                    this.deleteStandardIdsList.push(item.id)
                }
            }
            this.inputList.splice(index, 1);
            console.log(this.deleteStandardIdsList,'需要删除的');
        },
        handleClose() {
            this.$emit('backBtnAd')
        },
        AddClick() {
            this.deviceClick()
        },
        deviceClick() {
            this.loading = true
            let params = {}
            for (let item of this.inputList) {
                item.score = Number(item.score)
            } 
            if ( this.addtilie == '编辑' ) {
                let deleteStandardIdsList = []
                console.log(this.inputListDuibi,9999);
                for ( let item of JSON.parse(this.inputListDuibi) ) {
                    deleteStandardIdsList.push(item.id)
                }
                if ( this.Dform.radio == '1' ) {
                    params = {
                        name: this.Dform.name,
                        addScoreType: this.Dform.radio,
                        standards: this.inputList,
                        checkTaskId: this.ItemInfoobj.id,
                        id: JSON.parse(this.addItem).id,
                        deleteStandardIds:deleteStandardIdsList,
                    }
                } else if ( this.Dform.radio == '0' ) {
                    params = {
                        name: this.Dform.name,
                        addScoreType: this.Dform.radio,
                        standards: this.inputList,
                        checkTaskId: this.ItemInfoobj.id,
                        id: JSON.parse(this.addItem).id,
                        deleteStandardIds:deleteStandardIdsList,
                    }
                }
            } else {
                if ( this.Dform.radio == '1' ) {
                   
                    params = {
                        name: this.Dform.name,
                        addScoreType: this.Dform.radio,
                        standards: this.inputList,
                        checkTaskId: this.ItemInfoobj.id
                    }
                } else if ( this.Dform.radio == '0' ) {
                    params = {
                        name: this.Dform.name,
                        addScoreType: this.Dform.radio,
                        standards: this.inputList2,
                        checkTaskId: this.ItemInfoobj.id
                    }
                }
            }
            addOrUpdate(params).then((res) => {
                // console.log(res,'换机成功');
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });
                this.loading = false
                this.$emit('backBtnAd')

                // this.dialogVisible = false  
            }).catch((err) => {
                // console.log(err,'换机失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
    }
}




</script>
<style scoped lang="scss">

.dafen_box {
    display: flex;
    .inp_hou {
        margin-left: 10px;
    }
    :deep() {
        .el-form-item--small {
            width: auto !important;
        }
    }
    .jiahao_img {
        width: 20px;
        color: rgb(66, 119, 241);
        margin-bottom: 20px;
        cursor: pointer;
        margin-left: 10px;
    }
}
:deep() {
    .el-input--small .el-input__wrapper {
        height: 35px;
        line-height: 35px;
        text-align: center;
        // width: 280px;
    }

    .el-input__inner {
        // width: 100% !important;
    }

    .buttom-box {
        // text-align: center;
        // margin-left: 180px;

    }

    .el-form-item--small {
        width: 70% !important;
    }
}
</style>